<template>
    <div>
        <div class="card-sakali mt-3" v-if="emblem && emblemShapes">
            <div class="card-body">
                <!-- Form -->
                <div class="row form-group form-inline">
                    <div class="col-6 col-md-2">
                        <label for="formSelectButton">Form</label>
                    </div>
                    <div class="col-6 col-md-10 text-start">
                        <span v-html="shapeAsSVG"/>
                        <button id="formSelectButton"
                                class="btn btn-sm btn-sakali ms-2 my-auto"
                                @click="selectForm = true">
                            Wählen
                        </button>
                    </div>
                    <div v-if="selectForm"
                         class="bg-light rounded border-white position-absolute mx-2 py-2 shadow"
                         style="z-index: 99;"
                         v-on-clickaway="unsetSelectForm">
                        <div class="form-group">
                            <div class="form-check form-check-inline p-1"
                                 v-for="shape in emblemShapes"
                                 :key="shape.id"
                                 :value="shape.id">
                                <input class="form-check-input"
                                       type="radio"
                                       :id="'shape-radio-' + shape.id"
                                       value="option1"
                                       :checked="editedEmblem.s == shape.id"
                                       @change="editedEmblem.s = shape.id"/>
                                <label class="form-check-label" :for="'shape-radio-' + shape.id">
                                    <span v-html="shape.emblemSVG"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Label -->
                <div class="row form-group form-inline">
                    <label class="form-inline col-6 col-md-2" for="label">Beschriftung</label>
                    <input id="label" type="text" class="form-control form-text col-6 col-md-10" v-model="editedEmblem.l"/>
                </div>
                <!-- Scriftgröße -->
                <div class="row form-group form-inline flex-nowrap">
                    <label class="form-inline col-6 col-md-2" for="font-size">Schriftgröße</label>
                    <div id="font-size" class="col-6 col-md-10 d-inline-flex">
                        <fas icon="chevron-left" class="my-auto me-1" size="2x" @click="reduceFontSize"></fas>
                        <input type="number"
                               class="form-control form-text"
                               v-model="transposedFontSize"/>
                        <fas icon="chevron-right" class="my-auto ms-1" size="2x" @click="increaseFontSize"></fas>
                    </div>
                </div>
                <!-- Schriftart, kursiv, drehen -->
                <div class="row form-group flex-nowrap mx-1">
                    <div class="form-check form-check-inline col-4 col-md-2 offset-md-2">
                        <label class="form-inline" for="italic">Drehen</label>
                        <input class="form-check-input ms-2"
                               type="checkbox"
                               id="angle"
                               v-model="editedEmblem.fa"/>
                    </div>
                    <div class="form-check form-check-inline col-4 col-md-2 ">
                        <label class="form-inline" for="italic">Kursiv</label>
                        <input class="form-check-input ms-2"
                               type="checkbox"
                               id="italic"
                               v-model="editedEmblem.fi"/>
                    </div>
                    <div class="form-check form-check-inline col-4 col-md-2 ">
                        <label class="form-inline" for="serif">Serif</label>
                        <input class="form-check-input ms-2"
                               type="checkbox"
                               id="serif"
                               :checked="editedEmblem.fn === 'serif'"
                               @change="toggleFontType"/>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-4 col-md-2 offset-md-2 position-relative">
                        <label class="d-block" for="fontColor">Schriftfarbe</label>
                        <fas id="fontColor"
                             icon="square"
                             size="2x"
                             :style="{color:editedEmblem.fc}"
                             @click="selectFontColor = true">
                        </fas>
                        <color-picker :value="editedEmblem.fc"
                                      width="100%"
                                      @input="fontColorPicked"
                                      class="position-absolute"
                                      style="z-index: 99; bottom: 10vh; left: 0vw;"
                                      v-if="selectFontColor"
                                      v-on-clickaway="unsetSelectFontColor"/>
                    </div>
                    <div class="form-group col-4 col-md-2 position-relative">
                        <label class="d-block" for="primaryColor">Farbe 1</label>
                        <fas id="primaryColor"
                             icon="square"
                             class="my-auto ms-1"
                             size="2x"
                             :style="{color:editedEmblem.pc}"
                             @click="selectPrimaryColor = true">
                        </fas>
                        <color-picker :value="editedEmblem.pc"
                                      width="100%"
                                      @input="primaryColorPicked"
                                      class="position-absolute"
                                      style="z-index: 99; bottom: 10vh;"
                                      v-if="selectPrimaryColor"
                                      v-on-clickaway="unsetSelectPrimaryColor"/>
                    </div>
                    <div class="form-group col-4 col-md-2 position-relative">
                        <label class="d-block" for="secondaryColor">Farbe 2</label>
                        <fas id="secondaryColor"
                             icon="square"
                             class="my-auto ms-1"
                             size="2x"
                             :style="{color:editedEmblem.sc}"
                             @click="selectSecondaryColor = true">
                        </fas>
                        <color-picker :value="editedEmblem.sc"
                                      width="100%"
                                      @input="secondaryColorPicked"
                                      class="position-absolute"
                                      style="z-index: 99; bottom: 10vh; right: 5vw;"
                                      v-if="selectSecondaryColor"
                                      v-on-clickaway="unsetSelectSecondaryColor"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Sketch} from 'vue-color';
    import {mixin as clickaway} from 'vue-clickaway';

    export default {
        props: {
            emblem: Object,
            emblemSVG: String,
            emblemShapes: Array
        },
        data() {
            return {
                editedEmblem: this.emblem,
                selectPrimaryColor: false,
                selectSecondaryColor: false,
                selectFontColor: false,
                selectForm: false
            }
        },
        computed: {
            shapeAsSVG() {
                return this.emblemShapes[this.editedEmblem.s - 1].emblemSVG
            },
            transposedFontSize: {
                get() {
                    return Number.parseInt(Number.parseInt(this.editedEmblem.fs) / 10);
                },
                set(newValue) {
                    this.editedEmblem.fs = Number.parseInt(newValue) * 10;
                }
            }
        },
        methods: {
            unsetSelectForm() {
                this.selectForm = false;
            },
            primaryColorPicked(color) {
                this.editedEmblem.pc = color.hex;
            },
            unsetSelectPrimaryColor() {
                this.selectPrimaryColor = false;
            },
            secondaryColorPicked(color) {
                this.editedEmblem.sc = color.hex;
            },
            unsetSelectSecondaryColor() {
                this.selectSecondaryColor = false;
            },
            fontColorPicked(color) {
                this.editedEmblem.fc = color.hex;
            },
            reduceFontSize() {
                this.editedEmblem.fs = Math.max(Number.parseInt(this.editedEmblem.fs) - 10, 0);
            },
            increaseFontSize() {
                this.editedEmblem.fs = Number.parseInt(this.editedEmblem.fs) + 10;
            },
            unsetSelectFontColor() {
                this.selectFontColor = false;
            },
            toggleFontType() {
                if (this.editedEmblem.fn === 'serif')
                    this.editedEmblem.fn = 'sans-serif';
                else
                    this.editedEmblem.fn = 'serif';
            }
        },
        watch: {
            editedEmblem: {
                handler: function () {
                    window.console.info('changed!');
                    this.$emit('emblem-change', this.editedEmblem);
                },
                deep: true
            }
        },
        components: {
            'colorPicker': Sketch
        },
        mixins: [clickaway]
    }
</script>

<style>
    .vc-slider {
        width: 100%;
    }
</style>
